import { createElementBlock as l, openBlock as t, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function o(c, e) {
  return t(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      d: "M9.37 2 4 12l5.37 10h1.486l5.429-10-3.459-6.44-.78 1.454L14.722 12l-4.619 8.6L5.486 12l5.37-10zm3.077 0L7.02 12l3.458 6.44.781-1.454L8.581 12l4.618-8.6 4.619 8.6-5.37 10h1.485l5.37-10-5.37-10z"
    }, null, -1)
  ]));
}
const i = { render: o };
export {
  i as default,
  o as render
};
//# sourceMappingURL=ic_brand_renault-CXG-jfik.js.map
